<template>
  <v-container>
    <v-layout wrap justify-center>
      <v-card class="ma-0 pa-1 mt-0" width="400px">
        <v-form id="sensorPort">
          <div class="ma-2">센서노드 정보</div>

          <v-layout align-center class="ma-1 use-row">
            <v-text-field
              dense
              outlined
              hide-details
              class="shrink mr-1"
              style="height: 45px; width: 230px;"
              id="sensor_mac"
              ref="sensor_mac"
              label="센서노드 MAC✽"
              placeholder="mac주소를 입력해주세요."
              v-model="sensor_mac"
              :disabled="!!node_id"
              @keyup="sensorMacMask(sensor_mac)"
              maxlength="20"
              clearable
            />
            <!-- 센서정보 팝업 -->
            <v-dialog v-model="dialog" max-width="750" max-height="100">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="action_btn normal_btn_color"
                  style="height: 35px !important; border-radius: 20px !important;"
                  v-bind="attrs"
                  :loading="loadingCheckData"
                  id="checkData"
                  ref="checkData"
                  @click="(sensor_mac && sensor_mac.length === 12) || (sensor_mac && sensor_mac.length > 13) ? checkData() : $store.commit('resMessage', '맥 아이디를 확인하세요')"
                >
                  수신확인
                </v-btn>
              </template>

              <v-card class="dialog_content">
                <v-card-text>
                  <v-row class="text-center">
                    <v-col class="mb-5 mt-5">
                      <h2>{{ updated_at }}</h2>
                    </v-col>
                  </v-row>

                  <v-row align="center" justify="center">
                    <VueSvgGauge
                      v-if="chartData.temp1"
                      class="mini-gauge"
                      :start-angle="0"
                      :end-angle="360"
                      :value="chartData.temp1"
                      :min="-20"
                      :max="50"
                      :separator-step="0"
                      :scale-interval="10"
                      :inner-radius="80"
                    >
                      <div class="inner-text">
                        <div class="sensor_title">
                          <v-icon color="#3a4f3f">mdi-thermometer</v-icon>
                          온도
                        </div>
                        <span class="sensor_value">{{ chartData.temp1 }}</span>
                      </div>
                    </VueSvgGauge>

                    <VueSvgGauge
                      v-if="chartData.hum1"
                      class="mini-gauge"
                      :start-angle="0"
                      :end-angle="360"
                      :min="0"
                      :max="100"
                      :value="chartData.hum1"
                      :separator-step="0"
                      :scale-interval="10"
                      :inner-radius="80"
                    >
                      <div class="inner-text">
                        <div class="sensor_title">
                          <v-icon color="#3a4f3f">mdi-water</v-icon>
                          습도
                        </div>
                        <span class="sensor_value">{{ chartData.hum1 }}</span>
                      </div>
                    </VueSvgGauge>

                    <VueSvgGauge
                      v-if="chartData.co21"
                      class="mini-gauge"
                      :min="0"
                      :max="500"
                      :start-angle="0"
                      :end-angle="360"
                      :value="chartData.co21"
                      :separator-step="0"
                      :scale-interval="10"
                      :inner-radius="80"
                    >
                      <div class="inner-text">
                        <div class="sensor_title">
                          <v-icon color="#3a4f3f">mdi-weather-cloudy</v-icon>
                          이산화탄소
                        </div>
                        <span class="sensor_value">{{ chartData.co21 }}</span>
                      </div>
                    </VueSvgGauge>

                    <VueSvgGauge
                      v-if="chartData.nh31"
                      class="mini-gauge"
                      :start-angle="0"
                      :end-angle="360"
                      :min="0"
                      :max="100"
                      :value="chartData.nh31"
                      :separator-step="0"
                      :scale-interval="10"
                      :inner-radius="80"
                    >
                      <div class="inner-text">
                        <div class="sensor_title">
                          <v-icon color="#3a4f3f">mdi-waves</v-icon>
                          암모니아
                        </div>
                        <span class="sensor_value">{{ chartData.nh31 }}</span>
                      </div>
                    </VueSvgGauge>

                    <VueSvgGauge
                      v-if="chartData.h2s1 > -1"
                      class="mini-gauge"
                      :start-angle="0"
                      :end-angle="360"
                      :value="chartData.h2s1"
                      :separator-step="0"
                      :scale-interval="10"
                      :inner-radius="80"
                    >
                      <div class="inner-text">
                        <div class="sensor_title">
                          <v-icon color="#3a4f3f">mdi-weather-fog</v-icon>
                          황화수소
                        </div>
                        <span class="sensor_value">{{ chartData.h2s1 }}</span>
                      </div>
                    </VueSvgGauge>
                  </v-row>
                </v-card-text>

                <v-card-actions align-content-center>
                  <v-spacer></v-spacer>
                  <v-btn rounded class="new-btn" style="height: 30px; width: 20px; margin-bottom: 15px" id="confirm" ref="confirm" @click="dialog = false">
                    확인
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- 센서정보 팝업 끝 -->
          </v-layout>
          <v-autocomplete
            dense
            outlined
            class="ma-1"
            style="height: 45px"
            id="farm"
            ref="farm"
            label="농장✽"
            v-model="farm"
            :items="farmItems"
            :menu-props="{ top: false, offsetY: true }"
            item-text="name"
            item-value="code"
            return-object
            @change="changeFarm()"
            @focus="comboFarms()"
            clearable
          />
          <v-autocomplete
            dense
            outlined
            class="ma-1"
            style="height: 45px"
            id="building"
            ref="building"
            label="축사✽"
            v-model="building"
            :items="buildingItems"
            :menu-props="{ top: false, offsetY: true }"
            item-text="name"
            item-value="code"
            return-object
            @change="changeBuilding()"
            @focus="comboBuildings()"
            clearable
          />
          <v-autocomplete
            dense
            outlined
            class="ma-1"
            style="height: 45px"
            id="room"
            ref="room"
            label="방(위치)✽"
            v-model="room"
            :items="roomItems"
            :menu-props="{ top: false, offsetY: true }"
            item-text="name"
            item-value="code"
            return-object
            @change="changeRoom()"
            @focus="comboRooms()"
            clearable
          />
          <v-text-field dense outlined class="ma-1" style="height: 45px" id="device_name" ref="device_name" label="센서노드 이름✽" v-model="device_name" clearable />

          <div class="ma-2 mt-0 mb-0">포트별 정보</div>
          <v-simple-table dense class="ml-1 mr-1 port-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>포트</th>
                  <th>센서모델</th>
                  <th>방(위치)</th>
                  <th>패키지<br />품목</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="port in ports" :key="port.no">
                  <td class="port-no">{{ port.no }}</td>
                  <td>
                    <v-autocomplete
                      dense
                      outlined
                      hide-details
                      v-model="port.model"
                      :items="sensorModelItems"
                      item-text="label"
                      item-value="model"
                      placeholder="선택"
                      :menu-props="{ top: false, offsetY: true, minWidth: 220 }"
                      clearable
                    />
                  </td>
                  <td>
                    <v-autocomplete
                      dense
                      outlined
                      hide-details
                      v-model="port.room_cd"
                      :items="roomItems"
                      item-text="name"
                      item-value="code"
                      placeholder="선택"
                      :menu-props="{ top: false, offsetY: true, minWidth: 220 }"
                      clearable
                    />
                  </td>
                  <td class="port-package">
                    <v-checkbox dense hide-details class="ma-0 pa-0" v-model="port.package" />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-layout class="ma-1 mt-2 use-row" align-center justify-space-between>
            <v-menu v-model="menuRegdate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  outlined
                  clearable
                  class="shrink"
                  style="height: 45px; width: 250px"
                  id="regdate"
                  ref="regdate"
                  v-model="regdate"
                  label="등록일"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker no-title locale="ko-KR" v-model="regdate" @input="menuRegdate = false"></v-date-picker>
            </v-menu>
            <v-switch dense inset hide-details class="ma-0 pa-0 use-switch" id="useYn" ref="useYn" v-model="useYn" :label="useYn ? '사용' : '중지'" />
          </v-layout>
          <v-textarea dense outlined no-resize class="ma-1" rows="2" id="memo" ref="memo" label="비고" v-model="memo" persistent-hint :hint="chgHint" />

          <v-card-actions class="d-block">
            <v-row justify="center">
              <v-spacer></v-spacer>
              <v-btn rounded class="action_btn normal_btn_color mr-2" style="margin-bottom: 15px" :loading="loadingSave" id="save" ref="save" @click="saveNode()"> 저장 </v-btn>
              <v-btn rounded class="action_btn new_btn_color mr-2" style="margin-bottom: 15px" id="clear" ref="clear" @click="newSensorRegister()"> 새로등록 </v-btn>
              <v-btn rounded class="action_btn cancel_btn_color" style="margin-bottom: 15px" v-show="node_id" id="deleteNode" ref="deleteNode" @click="deleteNode()"> 삭제 </v-btn>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>

      <v-card class="ma-0 ml-1 mt-0" width="700px">
        <v-layout wrap align-center>
          <v-radio-group dense outlined row style="height: 30px; margin-left: 10px; margin-top: 2px" id="selOption" ref="selOption" v-model="selOption">
            <v-radio label="가동" value="live" color="#3a4f4f" @click="refreshList()"></v-radio>
            <v-radio label="중지" value="del" color="#88191A" @click="refreshList()"></v-radio>
            <v-radio label="전체" value="all" color="#004297" @click="refreshList()"></v-radio>
          </v-radio-group>
          <v-spacer></v-spacer>
          <a class="sensor-product-link mr-3 d-inline-flex align-center" href="#" @click.prevent="sensorProductDialog = true">
            센서 제품(모델) 정보 관리 <v-icon small color="#3a4f3f">mdi-open-in-new</v-icon>
          </a>
        </v-layout>

        <v-data-table
          dense
          nowrap
          height="600px"
          class="elevation-3 v-data-table"
          style="margin-left: 1px; margin-right: 0px"
          id="items"
          ref="items"
          :loading="loadingList"
          :headers="headers"
          :items="filteredItems"
          :items-per-page="50000"
          no-data-text="등록된 자료가 없거나 접근 권한이 없습니다."
          fixed-header
          hide-default-footer
          @click:row="infoDetail"
          sort-by="farm_name"
          group-by="farm_name"
          show-group-by
          item-key="rowKey"
          single-select
          :item-class="itemRowBackground"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th colspan="14">
              <v-icon @click="toggle">{{ isOpen ? "mdi-minus" : "mdi-plus" }}</v-icon>
              {{ items[0].farm_name }}
            </th>
          </template>
        </v-data-table>

        <v-card-title>
          <v-text-field dense style="width: 185px" class="shrink mr-3" clearable v-model="search" append-icon="mdi-magnify" label="농장,축명으로 찾기" single-line hide-details></v-text-field>

          <v-text-field
            dense
            style="width: 250px"
            class="shrink"
            clearable
            v-model="search2"
            append-icon="mdi-magnify"
            label="노드명,맥으로 찾기"
            single-line
            hide-details
            @keyup="searchMacMask(search2)"
          ></v-text-field>
        </v-card-title>

        <v-card-actions class="justify-center">
          <v-btn rounded-pill class="elevation-5 ma-3 rounded-pill refresh_btn normal_btn_color" style="height: 45px !important" id="refreshList" ref="refreshList" @click="refreshList()">
            <v-icon left dark>mdi-refresh</v-icon>
            목록고침
          </v-btn>
        </v-card-actions>
      </v-card>

      <SensorProductDialog v-model="sensorProductDialog" />
    </v-layout>
  </v-container>
</template>

<script>
import Apis from "@/api/apis";
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";
import URLS from "@/api/urls.js";
import { VueSvgGauge } from "vue-svg-gauge";
import SensorProductDialog from "./SensorProductDialog.vue";

function emptyPorts() {
  return [1, 2, 3, 4, 5, 6].map((no) => ({ no, model: "", room_cd: "", package: false }));
}

export default {
  name: "RegisterSensor",
  components: {
    VueSvgGauge,
    SensorProductDialog,
  },

  data: () => ({
    node_id: "",
    device_name: "",
    sensor_mac: "",

    dialog: false,
    updated_at: "-",
    loadingCheckData: false,
    receiveOK: false,
    chartData: {
      temp1: "",
      hum1: "",
      co21: "",
      nh31: "",
      h2s1: "",
    },

    company: {},
    farm: {},
    farmItems: [],
    building: {},
    buildingItems: [],
    room: {},
    roomItems: [],
    ports: emptyPorts(),
    regdate: "",
    menuRegdate: false,
    memo: "",
    useYn: true,
    chguser: "",
    chgdate: "",

    loadingSave: false,
    loadingList: false,

    sensorProductDialog: false,
    sensorModelItems: [],

    selOption: "all",
    search: "",
    search2: "",

    // TODO: 센서포트(신) 등록/수정/삭제 API 확정되면 연동
    items: [],

    headers: [
      { text: "농장", align: "left", value: "farm_name", sortable: false, groupable: false, width: "100px", class: "green darken-4 white--text" },
      { text: "건물", align: "left", value: "building_name", sortable: false, groupable: false, width: "130px", class: "green darken-4 white--text" },
      { text: "방/위치", align: "left", value: "room_name", sortable: false, groupable: false, width: "100px", class: "green darken-4 white--text" },
      { text: "센서노드 이름", align: "left", value: "device_name", sortable: false, groupable: false, width: "130px", class: "green darken-4 white--text" },
      { text: "센서노드 MAC", align: "left", value: "sensor_mac", sortable: false, groupable: false, width: "110px", class: "green darken-4 white--text" },
      { text: "포트1", align: "center", value: "port1", sortable: false, groupable: false, width: "70px", class: "green darken-4 white--text" },
      { text: "포트2", align: "center", value: "port2", sortable: false, groupable: false, width: "70px", class: "green darken-4 white--text" },
      { text: "포트3", align: "center", value: "port3", sortable: false, groupable: false, width: "70px", class: "green darken-4 white--text" },
      { text: "포트4", align: "center", value: "port4", sortable: false, groupable: false, width: "70px", class: "green darken-4 white--text" },
      { text: "포트5", align: "center", value: "port5", sortable: false, groupable: false, width: "70px", class: "green darken-4 white--text" },
      { text: "포트6", align: "center", value: "port6", sortable: false, groupable: false, width: "70px", class: "green darken-4 white--text" },
      { text: "설치일", align: "left", value: "setdate", sortable: false, groupable: false, width: "130px", class: "green darken-4 white--text" },
      { text: "중지일", align: "left", value: "deldate", sortable: false, groupable: false, width: "110px", class: "green darken-4 white--text" },
      { text: "비고", align: "left", value: "history", sortable: false, groupable: false, width: "200px", class: "green darken-4 white--text" },
      { text: "패키지품목", align: "center", value: "package_text", sortable: false, groupable: false, width: "100px", class: "green darken-4 white--text" },
    ],
  }),

  computed: {
    filteredItems() {
      const farmKeyword = this.search.trim().toLowerCase();
      const nodeKeyword = this.search2.trim().toLowerCase();
      return this.items.filter((item) => {
        if (farmKeyword) {
          const hay = `${item.farm_name}${item.building_name}`.toLowerCase();
          if (!hay.includes(farmKeyword)) return false;
        }
        if (nodeKeyword) {
          const hay = `${item.device_name}${item.sensor_mac}`.toLowerCase();
          if (!hay.includes(nodeKeyword)) return false;
        }
        return true;
      });
    },
    chgHint() {
      return this.chgdate && this.chguser ? `${this.chgdate}에 ${this.chguser}님이 최종 수정` : "";
    },
  },

  created() {
    Apis.pageCount(
      {
        page_name: this.$route.name,
        url: this.$route.path,
        division: "pigro",
      },
      () => {
        // 정상처리
      },
    ).catch((err) => {
      console.log("pageCount 호출 오류", err);
    });

    this.comboFarms();
    this.comboSensorModels();
    this.refreshList();
    sessionStorage.setItem("deviceTab", 3);
  },

  methods: {
    refreshList() {
      this.loadingList = true;
      return Apis.listSensorNodes(
        {
          sel: this.selOption === "all" ? "" : this.selOption,
        },
        (res) => {
          if (res.result) {
            this.items = res.data.map((item) => {
              const ports = {};
              const portDetails = {};
              let hasPackage = false;
              for (let no = 1; no <= 6; no++) {
                ports[`port${no}`] = item[no] ? item[no].model : "";
                portDetails[no] = item[no] ? { model: item[no].model, room_cd: item[no].room.code, package: !!item[no].package } : null;
                if (item[no] && item[no].package) hasPackage = true;
              }
              return {
                id: item.sensor_mac,
                rowKey: item.sensor_mac,
                device_name: item.device_name,
                sensor_mac: Common.getMacMask(item.sensor_mac),
                farm_name: item.room_cd.farm.name,
                farm_cd: item.room_cd.farm.code,
                building_name: item.room_cd.building.name,
                building_cd: item.room_cd.building.code,
                room_cd: item.room_cd.room.code,
                room_name: item.room_cd.room.name,
                ...ports,
                portDetails,
                setdate: item.setdate,
                deldate: "",
                history: item.history,
                package_text: hasPackage ? "포함" : "미포함",
                disabled: item.disabled,
              };
            });
          } else {
            this.items = [];
            alert(res.message);
          }
          this.loadingList = false;
        },
      ).catch((err) => {
        console.log("listSensorNodes API 호출 오류", err);
        this.loadingList = false;
        alert(err);
      });
    },
    itemRowBackground(item) {
      return item.id === this.node_id ? "selected" : "";
    },
    async infoDetail(item, row) {
      row.select(true);
      await Apis.infoSensorNode({ sensor_mac: item.id }, async (res) => {
        if (!res.result) {
          alert(res.message);
          return;
        }
        const data = res.data;
        const roomCode = data.room_cd.room.code;
        const roomName = data.room_cd.room.name;

        await Apis.comboRooms({
          company_cd: "",
          farm_cd: data.room_cd.farm.code,
          building_cd: data.room_cd.building.code,
          stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
        }, (roomRes) => {
          this.roomItems = roomRes.result
            ? roomRes.data.map((r) => ({
                building_cd: r.building_cd,
                code: r.room_cd,
                name: r.room_name,
              }))
            : [];
        }).catch((err) => {
          console.log("comboRooms API 호출 오류", err);
          this.roomItems = [];
          alert(err);
        });
        if (!this.roomItems.some((r) => r.code === roomCode)) {
          this.roomItems.push({ building_cd: data.room_cd.building.code, code: roomCode, name: roomName });
        }

        const modelFallback = [];
        [1, 2, 3, 4, 5, 6].forEach((no) => {
          const detail = data[no];
          if (detail && detail.model && !this.sensorModelItems.some((m) => m.model === detail.model)) {
            modelFallback.push({ model: detail.model, label: detail.model });
          }
        });
        if (modelFallback.length) {
          this.sensorModelItems = [...this.sensorModelItems, ...modelFallback];
        }

        this.node_id = data.sensor_mac;
        this.device_name = data.device_name;
        this.sensor_mac = Common.getMacMask(data.sensor_mac);
        this.memo = data.history;
        this.regdate = data.setdate;
        this.useYn = !data.disabled;
        this.receiveOK = false;
        this.chguser = data.chguser || "";
        this.chgdate = data.chgdate || "";

        this.ports = [1, 2, 3, 4, 5, 6].map((no) => {
          const detail = data[no];
          return {
            no,
            model: detail ? detail.model : "",
            room_cd: detail ? detail.room_cd.code : roomCode,
            package: !!(detail && detail.package),
          };
        });

        this.farm = { code: data.room_cd.farm.code, name: data.room_cd.farm.name };
        this.farmItems.push(this.farm);
        this.building = { code: data.room_cd.building.code, name: data.room_cd.building.name };
        this.buildingItems.push(this.building);
        this.room = { code: roomCode, name: roomName };
      }).catch((err) => {
        console.log("infoSensorNode API 호출 오류", err);
        alert(err);
      });
    },
    newSensorRegister() {
      if (!this.farm.code) {
        this.$store.commit("resMessage", "농장을 선택해주세요");
        return;
      }
      this.clearNodeData();
      this.$refs.device_name.focus();
    },
    clearNodeData() {
      this.node_id = "";
      this.device_name = "";
      this.sensor_mac = "";
      this.building = {};
      this.room = {};
      this.ports = emptyPorts();
      this.regdate = "";
      this.memo = "";
      this.useYn = true;
      this.receiveOK = false;
      this.chguser = "";
      this.chgdate = "";
    },
    normalizeMac(mac) {
      return (mac || "").replace(/:/g, "").toLowerCase();
    },
    chartClear() {
      this.updated_at = "수신 없음";
      this.chartData.temp1 = "";
      this.chartData.hum1 = "";
      this.chartData.co21 = "";
      this.chartData.nh31 = "";
      this.chartData.h2s1 = "";
    },
    checkData() {
      this.receiveOK = false;
      this.chartClear();
      const mac = this.sensor_mac.replace(/:/gi, "");
      this.dialog = false;

      if (mac.length !== 10 && mac.length < 12) {
        this.$store.commit("resMessage", "맥 아이디를 확인하세요");
        this.dialog = false;
        return;
      }
      this.loadingCheckData = true;
      this.$store.commit("resMessage", "");
      this.$axios
        .get(URLS.redis.lastValue + "/" + mac, null)
        .then((res) => {
          if (res.data) {
            this.chartData.temp1 = res.data.value.temp;
            this.chartData.hum1 = res.data.value.hum;
            this.chartData.co21 = res.data.value.co2;
            this.chartData.nh31 = res.data.value.nh3;
            this.chartData.h2s1 = res.data.value.h2s;

            this.updated_at = res.data.local_dt;
            this.$store.commit("resMessage", "정상 처리되었습니다.");
            this.loadingCheckData = false;
            this.dialog = true;
            this.receiveOK = true;
          } else {
            this.$store.commit("resMessage", "센서정보가 없습니다.");
            this.loadingCheckData = false;
            this.dialog = false;
          }
        });
    },
    checkNodeData() {
      if (!this.device_name.trim()) {
        this.$refs.device_name.focus();
        return "센서노드 이름을 입력하세요";
      }
      if (!this.sensor_mac) {
        this.$refs.sensor_mac.focus();
        return "센서노드 MAC을 입력하세요";
      }
      if (!/^[0-9a-f]{12}$/.test(this.normalizeMac(this.sensor_mac))) {
        this.$refs.sensor_mac.focus();
        return "센서노드 MAC이 유효하지 않습니다.";
      }
      if (!this.room.code) {
        this.$refs.room.focus();
        return "방(위치)을 선택해주세요";
      }
      if (!this.regdate) {
        this.$refs.regdate.focus();
        return "등록일을 선택해주세요";
      }
      return "";
    },
    saveNode() {
      const msg = this.checkNodeData();
      if (msg) {
        this.$store.commit("resMessage", msg);
        return;
      }
      if (!this.node_id && !this.receiveOK) {
        if (!confirm("데이터 수신이 확인 되지 않았습니다. \n 그래도 우선 등록 하시겠습니까?")) return;
      }
      this.loadingSave = true;
      const ports = this.ports
        .filter((port) => port.model)
        .map((port) => ({
          port: port.no,
          model: port.model,
          room_cd: port.room_cd || this.room.code,
          package: !!port.package,
        }));
      const payload = {
        sensor_mac: this.normalizeMac(this.sensor_mac),
        room_cd: this.room.code,
        device_name: this.device_name.trim(),
        history: this.memo,
        setdate: this.regdate,
        disabled: !this.useYn,
        ports,
      };
      const apiCall = this.node_id ? Apis.updateSensorNode : Apis.insertSensorNode;
      const apiName = this.node_id ? "updateSensorNode" : "insertSensorNode";
      apiCall(payload, (res) => {
        this.loadingSave = false;
        if (res.result) {
          this.$store.commit("resMessage", res.message);
          this.clearNodeData();
          this.refreshList();
        } else {
          alert(res.message);
        }
      }).catch((err) => {
        this.loadingSave = false;
        console.log(`${apiName} API 호출 오류`, err);
        alert(err);
      });
    },
    deleteNode() {
      if (!confirm("경고!!!\n 해당 센서노드가 완전히 제거됩니다 !!\n 제거후 복구는 불가능 합니다.\n\n 완전히 제거 하시겠습니까?")) return;
      const reason = prompt("제거 사유를 입력하세요", "");
      if (!reason) return;

      this.loadingSave = true;
      Apis.deleteSensor({
        sensor_mac: this.normalizeMac(this.sensor_mac),
        history: reason.trim(),
      }, (res) => {
        this.loadingSave = false;
        if (res.result) {
          this.$store.commit("resMessage", res.message);
          this.clearNodeData();
          this.refreshList();
        } else {
          alert(res.message);
        }
      }).catch((err) => {
        this.loadingSave = false;
        console.log("deleteSensor API 호출 오류", err);
        alert(err);
      });
    },
    changeRoom() {
      const roomCd = (this.room && this.room.code) || "";
      this.ports.forEach((port) => {
        port.room_cd = roomCd;
      });
    },
    changeFarm() {
      if (this.farm && this.farm.company_cd) {
        this.company = { code: this.farm.company_cd, name: this.farm.company_name };
      }
      this.building = {};
      this.room = {};
      this.comboBuildings();
    },
    changeBuilding() {
      this.room = {};
      this.comboRooms();
    },
    comboFarms() {
      Apis.comboFarms(
        {
          company_cd: "",
          stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
        },
        (res) => {
          if (res.result) {
            this.farmItems = res.data.map((f) => ({
              company_cd: f.company_cd,
              company_name: f.company_name,
              code: f.farm_cd,
              name: f.farm_name,
            }));
          } else {
            alert(res.message);
          }
        },
      ).catch((err) => {
        console.log("comboFarms API 호출 오류", err);
        alert(err);
      });
    },
    comboBuildings() {
      Apis.comboBuildings(
        {
          company_cd: (this.company && this.company.code) || "",
          farm_cd: (this.farm && this.farm.code) || "",
          stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
        },
        (res) => {
          if (res.result) {
            this.buildingItems = res.data.map((b) => ({
              company_cd: b.company_cd,
              farm_cd: b.farm_cd,
              code: b.building_cd,
              name: b.building_name,
            }));
          } else {
            alert(res.message);
          }
        },
      ).catch((err) => {
        console.log("comboBuildings API 호출 오류", err);
        alert(err);
      });
    },
    comboRooms() {
      Apis.comboRooms(
        {
          company_cd: (this.company && this.company.code) || "",
          farm_cd: (this.farm && this.farm.code) || "",
          building_cd: (this.building && this.building.code) || "",
          stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
        },
        (res) => {
          if (res.result) {
            this.roomItems = res.data.map((r) => ({
              building_cd: r.building_cd,
              code: r.room_cd,
              name: r.room_name,
            }));
          } else {
            alert(res.message);
          }
        },
      ).catch((err) => {
        console.log("comboRooms API 호출 오류", err);
        alert(err);
      });
    },
    comboSensorModels() {
      Apis.listSensorModels(
        {
          sel: "live",
        },
        (res) => {
          if (res.result) {
            this.sensorModelItems = res.data.map((item) => ({
              model: item.model,
              label: `${item.model} (${item.type ? item.type.description : ""})`,
            }));
          } else {
            this.sensorModelItems = [];
          }
        },
      ).catch((err) => {
        console.log("listSensorModels API 호출 오류", err);
        alert(err);
      });
    },
    sensorMacMask(val) {
      this.sensor_mac = Common.getMacMask(val);
    },
    searchMacMask(val) {
      this.search2 = Common.getMacMask(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-data-table::v-deep {
  thead.v-data-table-header tr {
    th {
      background-color: #436251 !important;
      color: white !important;
      font-size: 13px;
      height: 40px !important;
    }
  }
}
.dialog_content {
  padding: 10px;
  border-radius: 30px;
}
::v-deep .v-dialog.v-dialog--active.v-dialog--scrollable {
  border-radius: 30px;
  overflow: hidden;
}
h2 {
  letter-spacing: -1px;
}
.mini-gauge {
  margin-right: 10px;
  max-width: 130px;
  .inner-text {
    width: 100%;
    height: 100%;
  }
}
.inner-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #3a4f3f;
  font-weight: bold;
}
.sensor_title {
  font-size: 1.5rem;
  letter-spacing: -1px;
  text-align: center;
}
.sensor_value {
  margin-top: 5px;
  font-size: 1.3rem;
}
.port-table ::v-deep table {
  table-layout: fixed;
  width: 100%;
}
.port-table ::v-deep td,
.port-table ::v-deep th {
  padding: 0 !important;
  border: none !important;
}
.port-table ::v-deep td:last-child,
.port-table ::v-deep th:last-child {
  padding-right: 0 !important;
}
.port-table ::v-deep td:nth-child(2),
.port-table ::v-deep th:nth-child(2) {
  padding-right: 4px !important;
}
.port-table ::v-deep th:last-child {
  width: 46px;
  white-space: normal;
  line-height: 1.2;
  font-size: 10.5px;
}
.port-table ::v-deep .v-input__slot,
.port-table ::v-deep .v-select__slot {
  min-width: 0;
}
.port-table ::v-deep .v-select__slot input[type="text"] {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
}
.port-table ::v-deep .v-input__icon {
  width: 16px;
  min-width: 16px;
}
.port-table ::v-deep .v-input__icon .v-icon {
  font-size: 14px;
}
.port-table ::v-deep .v-data-table {
  box-shadow: none !important;
}
.port-table ::v-deep th {
  text-align: center !important;
}
.port-table ::v-deep th:first-child {
  width: 34px;
  font-size: 10.5px;
}
.port-table ::v-deep .v-select {
  margin: 4px 0;
  width: 100%;
}
.port-table .port-no {
  width: 34px;
  text-align: center;
}
.port-table .port-package {
  width: 46px;
  text-align: center;
}
.port-table .port-package ::v-deep .v-input__slot {
  justify-content: center;
}
.port-table .port-package ::v-deep .v-input--selection-controls__input {
  margin-right: 0;
}
.use-row {
  height: 45px;
}
.use-row ::v-deep .use-switch {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}
.use-row ::v-deep .use-switch .v-input__control,
.use-row ::v-deep .use-switch .v-input__slot,
.use-row ::v-deep .use-switch .v-messages {
  margin: 0 !important;
  min-height: auto !important;
}
.use-row ::v-deep .use-switch .v-label {
  white-space: nowrap;
}
.use-row ::v-deep .use-switch .v-input--selection-controls__input {
  margin-right: 4px;
}
.sensor-product-link {
  color: #3a4f3f;
  font-weight: bold;
  text-decoration: underline;
  font-size: 13px;
}
.action_btn {
  width: 70px;
  height: 35px !important;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: -0.5px;
  border-color: transparent;
}
.refresh_btn {
  width: 100px;
  height: 35px !important;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: -0.5px;
  border-color: transparent;
}
.normal_btn_color {
  background-color: #3a4f3f !important;
  color: white;
}
.new_btn_color {
  background-color: rgb(245, 245, 245) !important;
  color: rgb(68, 68, 68);
}
.cancel_btn_color {
  background-color: #88191a !important;
  color: white;
}
</style>
